import React, { useState } from "react";
import { Image as ImageIcon, X, Send, Loader2 } from "lucide-react";
import Modal from "@/components/chat/Modal";
import api from "@/lib/api";
import { uploadFileChunked } from "@/lib/uploads";
import { toast } from "sonner";

export default function SuggestionDialog({ onClose }) {
  const [text, setText] = useState("");
  const [atts, setAtts] = useState([]); // {url,name,type}
  const [busy, setBusy] = useState(false);

  const addPhoto = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try { const { url, name } = await uploadFileChunked(f); setAtts((a) => [...a, { url, name, type: "image" }]); }
    catch (err) { toast.error("Upload failed"); } finally { setBusy(false); e.target.value = ""; }
  };

  const submit = async () => {
    if (!text.trim()) return;
    setBusy(true);
    try {
      await api.post("/suggestions", { text, attachments: atts });
      toast.success("Thank you! Your suggestion was sent 🙏");
      onClose();
    } catch (e) { toast.error("Failed to send"); } finally { setBusy(false); }
  };

  return (
    <Modal title="Send a suggestion" onClose={onClose}>
      <p className="text-sm text-[var(--rc-muted)] mb-3">Tell us what would make RoyalChat Nova better. You can attach a screenshot.</p>
      <textarea rows={5} value={text} onChange={(e) => setText(e.target.value)} placeholder="Your idea or issue…" data-testid="suggestion-text"
        className="w-full bg-[var(--rc-bg)] border border-[var(--rc-border)] rounded-2xl px-4 py-3 focus:outline-none focus:border-[var(--rc-gold)]/50" />
      {atts.length > 0 && (
        <div className="flex gap-2 mt-3 flex-wrap">
          {atts.map((a, i) => (
            <div key={i} className="relative">
              <img src={a.url} alt="" className="h-16 w-16 rounded-xl object-cover border border-[var(--rc-border)]" />
              <button onClick={() => setAtts(atts.filter((_, j) => j !== i))} className="absolute -top-2 -right-2 h-5 w-5 grid place-items-center rounded-full bg-red-500 text-white"><X size={12} /></button>
            </div>
          ))}
        </div>
      )}
      <div className="flex items-center gap-2 mt-4">
        <label className="flex items-center gap-2 rounded-full border border-[var(--rc-border)] px-4 py-2 text-sm cursor-pointer" data-testid="suggestion-attach">
          <ImageIcon size={16} /> Add photo <input type="file" accept="image/*" hidden onChange={addPhoto} />
        </label>
        <button onClick={submit} disabled={busy || !text.trim()} data-testid="suggestion-submit"
          className="ml-auto flex items-center gap-2 rounded-full bg-[var(--rc-gold)] text-black font-semibold px-6 py-2.5 disabled:opacity-50">
          {busy ? <Loader2 size={16} className="animate-spin" /> : <Send size={16} />} Send
        </button>
      </div>
    </Modal>
  );
}
